import { ALLOWED_TYPES, MAX_FILE_BYTES, MAX_FILES } from "./useCopilotController";

const locale = (lang) => (lang === "ar" ? "ar-SA" : "en-GB");

const sameDay = (a, b) => a.toDateString() === b.toDateString();

// Today: the time. Otherwise: the date.
export function formatListTime(iso, lang) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return sameDay(date, new Date())
    ? date.toLocaleTimeString(locale(lang), { hour: "2-digit", minute: "2-digit" })
    : date.toLocaleDateString(locale(lang), { day: "numeric", month: "short" });
}

export function formatMessageTime(iso, lang) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const time = date.toLocaleTimeString(locale(lang), { hour: "2-digit", minute: "2-digit" });
  return sameDay(date, new Date()) ? time : `${date.toLocaleDateString(locale(lang), { day: "numeric", month: "short" })} ${time}`;
}

export function formatFileSize(bytes) {
  if (!bytes) return "";
  return bytes < 1024 * 1024 ? `${Math.max(1, Math.round(bytes / 1024))} KB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

// Returns { files, error } after adding `incoming` to `current`.
export function addFiles(current, incoming, t) {
  const next = [...current];
  let error = null;
  for (const file of incoming) {
    if (!ALLOWED_TYPES.includes(file.type)) error = t.fileType;
    else if (file.size > MAX_FILE_BYTES) error = t.fileSize;
    else if (next.length >= MAX_FILES) error = t.fileCount;
    else next.push(file);
  }
  return { files: next, error };
}

// The backend's two customer-visible notices, in Arabic when needed.
const EVENT_AR = {
  "Conversation resolved": "تم حل المحادثة",
  "Conversation reopened": "تمت إعادة فتح المحادثة",
};
export const eventText = (text, lang) => (lang === "ar" ? EVENT_AR[text] || text : text);
